import { Result, failure, success } from '../shared'
import { OpDayProvider } from './opday.provider'
import {
  OpDayServiceErrorCode,
  OpDayFailure,
  OpDayViewAction,
  OpDayOperAction,
  OpDayViewServerData,
  OpDayValidateServerData,
} from './opday.types'

export class OpDayService {
  constructor(private provider: OpDayProvider) {}

  public async get(): Promise<Result<OpDayViewServerData, OpDayFailure>> {
    try {
      const { data } = await this.provider.view<OpDayViewServerData>(OpDayViewAction.View)
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text || 'HINT_ERR_TITLE',
      })
    }
  }

  public async validate(): Promise<Result<OpDayValidateServerData, OpDayFailure>> {
    try {
      const { data } = await this.provider.view<OpDayValidateServerData>(OpDayViewAction.Validate)
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async validateViewResult(sessionId: number, sessionHash: string): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.view<any>(OpDayViewAction.ValidateViewResults, {
        WHLSessionID: sessionId,
        HashSum_WHLSessionID_: sessionHash,
      })
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getStatus(sessionId: number): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.view<any>(OpDayViewAction.Status, {
        Ident: sessionId,
      })
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async block(): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.oper<any>(OpDayOperAction.Block)
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async unblock(): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.oper<any>(OpDayOperAction.Unblock)
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async open(): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.oper<any>(OpDayOperAction.Open)
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async close(): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.oper<any>(OpDayOperAction.Close)
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async openAccountOnly(): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.oper<any>(OpDayOperAction.OpenAccountOnly)
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async closeAccountOnly(): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.oper<any>(OpDayOperAction.CloseAccountOnly)
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async lock(lockDate: string): Promise<Result<any, OpDayFailure>> {
    try {
      const { data } = await this.provider.oper<any>(OpDayOperAction.Lock, {
        BlockDate: lockDate,
      })
      return success(data)
    } catch (error) {
      return failure(OpDayServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
